import { useId } from 'react';

/** Brand-gradient quotation marks (the player card's description box). */
export default function QuoteMarks({ className }: { className?: string }) {
  // Baked gradient + filter: ids must be unique per instance or later copies paint blank.
  const uid = useId().replace(/:/g, '');

  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter={`url(#${uid}f)`}>
        <path
          d="M3.36434 19.5776C2.15128 18.2578 1.5 16.7776 1.5 14.378C1.5 10.4273 4.03335 6.85986 7.80632 4.88447C8.25583 4.64912 8.80273 4.81781 9.074 5.2466C9.3884 5.74356 9.21559 6.39949 8.72612 6.72542C5.59954 8.80736 4.93199 11.313 4.65159 12.9436C5.28403 12.6082 6.11197 12.4912 6.92342 12.5684C9.04803 12.7699 10.7228 14.5566 10.7228 16.7776C10.7228 17.8974 10.2885 18.9714 9.51544 19.7633C8.74241 20.5551 7.69396 21 6.60072 21C5.99614 20.9947 5.39863 20.8661 4.843 20.622C4.28737 20.3778 3.78473 20.0228 3.36434 19.5776ZM15.1416 19.5776C13.9285 18.2578 13.2772 16.7776 13.2772 14.378C13.2772 10.4273 15.8106 6.85986 19.5836 4.88447C20.0331 4.64912 20.58 4.81781 20.8512 5.2466C21.1656 5.74356 20.9928 6.39949 20.5034 6.72542C17.3768 8.80736 16.7092 11.313 16.4288 12.9436C17.0613 12.6082 17.8892 12.4912 18.7007 12.5684C20.8253 12.7699 22.5 14.5566 22.5 16.7776C22.5 17.8974 22.0657 18.9714 21.2927 19.7633C20.5197 20.5551 19.4712 21 18.378 21C17.7734 20.9947 17.1759 20.8661 16.6202 20.622C16.0646 20.3778 15.562 20.0228 15.1416 19.5776Z"
          fill={`url(#${uid}g)`}
        />
      </g>
      <defs>
        <filter
          id={`${uid}f`}
          x="1.5"
          y="4.27779"
          width="21"
          height="16.7222"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.5" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.721569 0 0 0 0 0.188235 0 0 0 0 0.0784314 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="shape" result="innerShadow" />
        </filter>
        <radialGradient
          id={`${uid}g`}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-0.0211037 14.025 -17.85 -0.0104564 12.0211 6.975)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0243049" stopColor="#FF8861" />
          <stop offset="0.545037" stopColor="#FF5C33" />
          <stop offset="1" stopColor="#B62400" />
        </radialGradient>
      </defs>
    </svg>
  );
}
